import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { t } from 'i18next';
import { SiteSetupContext } from 'src/js/modules/site-setup/helpers/site-setup-context';

const { TemplatePreviewContainer } = designSystem;
const DEFAULT_PREVIEW_SRC = '/images/default-template-preview.jpg';

const TemplateThumb = ({
  name,
  previewUrl = '',
  templateSlug,
  onTemplatePreviewClick,
  onTemplateEditClick,
  layout3Cols = false,
  isLoading,
  isAISiteWizardEnabled = false,
}) => {
  const context = useContext(SiteSetupContext);
  const { archetype } = context.getData();
  const startEditingText =
    archetype && !isAISiteWizardEnabled ? t('Use this template') : t('Start editing');

  const handlePreviewClick = () => {
    onTemplatePreviewClick(templateSlug);
  };

  const handleEditClick = () => {
    onTemplateEditClick(templateSlug);
  };

  return (
    <TemplatePreviewContainer
      isLoading={isLoading}
      title={name}
      previewUrl={previewUrl || DEFAULT_PREVIEW_SRC}
      onPreviewClick={handlePreviewClick}
      onStartEditingClick={handleEditClick}
      captions={{
        preview: t('Preview'),
        startEditing: startEditingText,
      }}
      layout3Cols={layout3Cols}
    />
  );
};

TemplateThumb.propTypes = {
  name: PropTypes.string.isRequired,
  previewUrl: PropTypes.string,
  templateSlug: PropTypes.string.isRequired,
  onTemplatePreviewClick: PropTypes.func.isRequired,
  onTemplateEditClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAISiteWizardEnabled: PropTypes.bool,
  layout3Cols: PropTypes.bool,
};

export default TemplateThumb;
